import { Box, Divider, Text } from '@cmpsr/components';
import { text } from '../../../common/theme';
import RiskPercentage from '../risk-percentage/RiskPercentage';

interface RiskAnalysisCardProps {
  riskScore?: number;
}

const RiskAnalysisCard = ({ riskScore = 46 }: RiskAnalysisCardProps) => (
  <Box
    display="flex"
    width={{ base: '335px', lg: '600px' }}
    flexDirection="column"
    justifyContent="center"
    alignItems="center"
    gap={{ base: 'spacer-3', lg: 'spacer-5' }}
    alignSelf={{ lg: 'stretch' }}
  >
    <RiskPercentage riskScore={riskScore} />

    <Box width={{ base: '285px', lg: '350px' }} px={{ base: 'spacer-2', lg: 'spacer-5' }}>
      <Divider orientation="horizontal" borderColor="med-blue" />
    </Box>

    <Box
      display="flex"
      flexDirection="column"
      alignItems="center"
      gap="spacer-4"
      px={{ base: 'spacer-4', lg: 'spacer-24' }}
    >
      <Text color="white" textAlign="center" {...text.body.regular}>
        Only{' '}
        <Text as="span" color="salmon-light" {...text.body.bold}>
          25 of 500+
        </Text>{' '}
        risk factors analyzed so far
      </Text>
    </Box>
  </Box>
);

export default RiskAnalysisCard;
